<template>
    <v-container fluid class="maintenance-container pa-0">

        <Titulo />

        <v-row class="maintenance-content ma-0" justify="center" align="center">
            <v-col cols="12" sm="10" md="8" lg="6" class="d-flex justify-center">

                <v-card class="maintenance-card" elevation="8">

                    <v-chip color="#4F74E3" dark class="mb-6" large>
                        <v-icon left>
                            mdi-tools
                        </v-icon>
                        En mantenimiento
                    </v-chip>

                    <h1 class="title">
                        Estamos realizando mejoras
                    </h1>

                    <p class="subtitle">
                        Nuestro sitio se encuentra temporalmente en mantenimiento
                        para ofrecerte una mejor experiencia.
                    </p>

                    <div :class="imageClass">
                        <v-img :src="MaintenanceImage" contain max-width="300" max-height="300" class="mx-auto" />
                    </div>

                    <v-divider class="my-5"></v-divider>

                    <p class="message">
                        Lamentamos los inconvenientes.
                        <br>
                        Estaremos nuevamente disponibles en breve.
                    </p>

                </v-card>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import MaintenanceImage from "@/assets/images/mantenimiento.png";
import Titulo from "./Titulo.vue";

export default {
    components: {
        Titulo,
    },

    data() {
        return {
            MaintenanceImage,
            imageClass: "",
            screen: window.innerWidth,
        };
    },

    mounted() {
        document.body.setAttribute("data-sku", "MAINTENANCE");
        this.imageClass = this.screen > 800 ? "image" : "image2";
    },
};
</script>

<style scoped>
.maintenance-container {
    background: #f5f7fb;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
}

.maintenance-content {
    flex: 1;
    height: calc(100vh - 120px);
    padding: 10px 16px 20px;
    align-items: flex-start;
}

.maintenance-card {
    width: 100%;
    max-width: 680px;
    padding: 35px 30px;
    border-radius: 22px;
    text-align: center;

    margin-top: -35px;
}

.title {
    font-family: Helvetica, Arial, sans-serif;
    font-size: 34px;
    font-weight: 700;
    color: #4F74E3;
    margin-bottom: 18px;
}

.subtitle {
    font-size: 18px;
    color: #616161;
    line-height: 30px;
    margin-bottom: 30px;
}

.message {
    color: #757575;
    font-size: 16px;
    line-height: 28px;
}

.image {
    width: 38%;
    margin: auto;
}

.image2 {
    width: 75%;
    margin: auto;
}

/* -------- Tablet -------- */

@media (max-width: 960px) {

    .maintenance-card {
        padding: 28px 20px;
    }

    .title {
        font-size: 28px;
    }

    .subtitle {
        font-size: 16px;
        line-height: 25px;
    }

    .message {
        font-size: 15px;
    }

    .image {
        width: 55%;
    }

    .image2 {
        width: 80%;
    }
}

/* -------- Celulares -------- */

@media (max-width: 600px) {

    .maintenance-content {
        min-height: auto;
        height: auto;
        padding: 0 12px 20px;
        align-items: flex-start;
    }

    .maintenance-card {
        padding: 20px 16px;
        border-radius: 16px;
        margin-top: -50px;
        /* antes -25px */
    }

    .image,
    .image2 {
        width: 85%;
    }
}
</style>